import logo from './pictures/mtg_dots.png';
import './App.css';
import Footer from "./Footer"
import PositionedMenu from "./menu"

import { useState, } from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import ReactMarkdown from "react-markdown";



function App() {
  const [prompt, setPrompt] = useState('');
  const [showText, setShowText] = useState(true);
  const [showLoading, setLoading] = useState(false);
  const [showAnswer, setAnswer] = useState(false);
  var [cards, setScryfall] = useState('');
  const [uginAnswer, setUginAnswer] = useState('');




  return (
    <div className="App">
      <div><PositionedMenu /></div>
      <header className="App-header background">
      <Box sx={{ flexGrow: 1 }}>
        <Grid container 
        spacing={2} 
        size={{sm:6,md:8}}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}>
          
          <Grid container
          alignItems="center"
          justifyContent="center"
          size={{sm:6,md:8}}
          className="black-box texture-color">

          {/*Submitting the prompt*/}
          {showText && (
                <>
          <h1>
              You've yelled JUDGE!
              Ugin Appears:
        
            "Please state your question Planeswalker."
          </h1>
          <p> Please use brackets (e.g. [black lotus]) to pull card information.</p>
          <input 
              type="text" 
              placeholder="Enter Your Question Planeswalker!" 
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              className="App-input"
            />
            
            <button 
            className="App-button" 
            onClick={() => handleSubmission(prompt)}>
              Submit
            </button>
            
            </>
            )}
          {/*After the prompt is submitted the loading is displayed*/}

            {showLoading && !showAnswer && (
              <div className="loading-spinner">
                <div className="loading-frame">
                  <img 
                src= {logo}
                alt="Loading..." 
                className="rotating-loader" />
                </div>
                
              </div>
            )}

          {/*When an answer is returned it will be displayed*/}
            {showAnswer && (
              <Grid container spacing={1} size="grow" columns={{sx:1, md:2}}> 
              <Grid size={{sm:1, md:2}}>
              {prompt}
                <p> Disclaimer: AI insights are not always correct but are actively improving! </p>
              </Grid>
                <Grid size={{sm:1, md:1}}>
                  <div className='searchResults'>
                    <p>Ugin States: </p>
                    <ReactMarkdown className="uginAnswer">{uginAnswer.replace(/\\n/g, "\n")}</ReactMarkdown>
                    </div>
                </Grid>
                <Grid size={{sm:1, md:1}}>
                  <div className='scroll'>
                    { cleanOutput().map((element, i) => (
                      <div key={i} className='searchResults'>
                        {element}    
                      </div>
                    ))}
                  </div> 
                </Grid>
                <button className="App-button" onClick={refreshPage}>New Question</button>
              </Grid>  
            )} 



            </Grid>
        </Grid>
    </Box>
      </header>
      <div><Footer /></div>
    </div>
  );
  function handleSubmission(userInput) {
    setPrompt(userInput);
    setShowText(false); // Hide the text
    setLoading(true);
    handleChat(prompt);
    setTimeout(() => {
      setLoading(false);
      setAnswer(true);
    }, 10000000);
  }
  function cleanOutput() {
    var results = cards.split('\n');
    return results;
  }
  
  async function handleChat(userInput) {
    const key = process.env.REACT_APP_ASKUGIN_API_KEY;
    const url = new URL('https://mtg-ai-server.onrender.com/posts/quest');
    url.searchParams.append('question', userInput);
    await fetch(url, { 
      method: 'GET',
      headers: { 
        'Access-Control-Allow-Origin': 'True',
        'Content-Type': 'application/json',
        'Authorization': key,
        'HTTP-Referer': 'askugin.com',
        'X-Title': 'Ask Ugin'
      }
      })
      .then(response => response.json())
      .then(thang => {
        setUginAnswer(thang.answer);
        setScryfall(thang.cards); 
        setLoading(false);
        setAnswer(true);})
      .catch(error => console.error(error));
  }
  function refreshPage(){ 
    window.location.reload(); 
}
  
}

// End of Pretty Code



export default App;
